t<template>
  <div class="content">
    <div style="margin-bottom: 15px;">
      <TitleTag style="margin-left:0px">
        <span slot="title">
          <!-- {{$t('message.title.history')}} -->
          {{ $t("message.title.projectSchedule") }}
          <span class="process-title">共{{ tableData.length }}条项目
            <span v-show="threeProjectState">
              <span v-for="(item, index) in textList" :key="index"> {{ item.label + ': ' + processData[index]
                + '条' }}</span>
            </span>
          </span>
        </span>
      </TitleTag>
    </div>

    <div>
      <el-row>
        <el-col class="pro" :span="12">
          <div class="pro-title">
            <div class="item" v-for="item in statusColor" :key="item.id">
              {{ item.name }}
              <div class="proxx" :style="{ backgroundColor: item.color }"></div>
            </div>
          </div>
        </el-col>
        <el-col :span="11" style="float:right">
          <div style="float:right">
            <div class="leftButton">
              <el-dropdown split-button :type="primaryButton" size="small" @click="handleClick"
                @command="handleCommand">
                {{ dropLabel }}
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="item in labelFilterList " :command="commandValue(item)" :key="item.index">
                    {{ item.label }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="rightButton">
              <el-radio-group v-model="specialState" size="small" @change="typeClick">
                <el-radio-button v-for="item in typeList" :label="item.label" :name="item.value"
                  :key="item.value"></el-radio-button>
              </el-radio-group>
            </div>
          </div>
        </el-col>
      </el-row>

      <!--管道图部分  -->
      <div class="row-items">
        <el-row v-for="item in tableData" :key="item.index" class="proRow">
          <!-- 左侧项目整体完成率 -->
          <el-col :span="3" class="pro-left" @click="routeLink(item)">
            <div class="title" style="padding-left:8px" @click="routeLink(item)">
              <div class="item-name" :title="item.name">{{ item.name }}</div>
              <div class="item-name" :title="'完成率： ' + item.percentComplete + '%'">
                {{ "完成率： " + item.percentComplete + "%" }}
              </div>
            </div>
          </el-col>
          <!--子任务部分  -->
          <div style="width:88%; float:right">
            <el-col :span="24">
              <Progre :progressContent="item.children" @clickLink="routeLink"></Progre>
            </el-col>
          </div>
        </el-row>
      </div>

      <!-- <el-empty v-if="this.tableData.length==0" description="无"></el-empty> -->
      <div v-if="!tableData.length">
        <my-empty />
      </div>
    </div>
  </div>
</template>

<script>
//let echarts = require("echarts/lib/echarts");
// import axios from 'axios';
import TitleTag from "@/components/titleTag";
import MyEmpty from "@/views/components/empty.vue";
import Progre from "./progre.vue"; //子任务模块
// import {TaskList} from '@/utils/taskPur.js'   //TaskList为演示用模拟数据，等后端数据完成后将启用数据
import axios from "axios";

export default {
  components: {
    Progre,
    TitleTag,
    MyEmpty
  },
  props: ['elementHeight'],
  data() {
    return {
      tableData: [],
      tableTitle: [],
      tempIndex: [],
      baseData: [],
      threeProjectState: true,

      processData: [],
      specialState: "",
      allState: "",

      dropLabel: this.$t("message.title.proNormalState"),
      dropList: [
        { value: 0, label: '待办' },
        { value: 1, label: '进行中' },
        { value: 2, label: '已完成' },
        { value: 3, label: '正常状态' },
      ],
      typeList: [
        // { value: 0, label: this.$t("message.title.proNormalState") },
        { value: '1', label: this.$t("message.title.prosuspended") },
        { value: '2', label: this.$t("message.title.proShutDown") },
      ],
      statusColor: [
        { id: 1, color: "#13ce66", name: this.$t("message.title.tasknormal") },
        { id: 2, color: "#fcad2c", name: this.$t("message.title.taskOverdue") },
        { id: 3, color: "#F56C6C", name: this.$t("message.title.taskDelay") },
        // {id:4,color: '#38a8f6',name:this.$t("message.title.taskSuspended")},
        // {id:5,color: '#999',name:this.$t("message.title.taskClose")}
      ],
    };
  },
  computed: {
    primaryButton() {
      return !this.specialState ? 'primary' : '';
    },
    labelFilterList() {
      return this.dropList.filter(i => i.label != this.dropLabel);
    },
    textList() {
      return this.dropList.filter(i => i.value != 3)
    }
  },
  created() {
    this.processData = Array(3).fill(0);
    console.log(this.elementHeight);
  },
  mounted() {
    this.getData();
  },
  methods: {

    handleClick() {
      let item = this.dropList.find(i => i.label == this.dropLabel);
      this.handleCommand(item);
    },
    typeClick() {
      const n = this.typeList.find((i) => i.label == this.specialState).value;
      this.threeProjectState = !!n;
      this.getData(n);
    },
    commandValue(command) {
      return command;
    },

    async getData(n) {
      const id = n || 0;
      const { data: res } = await axios.get(
        "ppm/project/getTubular?specialState=" + id
      );
      // console.log(res);
      this.tableData = [...res.object.list]
      if (!n) {
        this.baseData = [...res.object.list];
      }
      let arr = Array(3).fill(0);
      this.tableData.map((i) => {
        if (!i.percentComplete) {
          arr[0]++;
        } else if (i.percentComplete == 100) {
          arr[2]++;
        } else {
          arr[1]++;
        }
      });
      this.processData = arr;
    },

    handleCommand(item) {

      console.log(this.baseData);

      this.specialState = '';
      this.threeProjectState = item.value == '3';
      this.dropLabel = item.label;
      switch (item.value) {
        case 0: this.tableData = this.baseData.filter(i => i.percentComplete == 0);
          break;
        case 2: this.tableData = this.baseData.filter(i => i.percentComplete == 100);
          break;
        case 1: this.tableData = this.baseData.filter(i => i.percentComplete != 0 && i.percentComplete != 100);
          break;
        default: this.tableData = [...this.baseData];
          var arr = Array(3).fill(0);
          this.tableData.map((i) => {
            if (!i.percentComplete) {
              arr[0]++;
            } else if (i.percentComplete == 100) {
              arr[2]++;
            } else {
              arr[1]++;
            }
          });
          this.processData = arr;
          break;
      }
    },
    routeLink(e) {
      // console.log(e);
      // let m = {
      //   itemClassId: e.classId,
      //   itemSubClassId: e.subclassId,
      //   itemId: e.id,
      //   rootId: e.rootId,
      //   "0": e.name,
      // };
      // //this.$store.commit("setClassId", e.classId);
      // //this.$store.commit("setObjID", e.id);
      // //this.$store.commit("setSubClassId", e.subclassId);
      // //this.$store.commit("setTabID", 0);
      // this.getRouteLink(m);

      const item = {
        ...e,
        name: e.name
      }
      this.getLink(item);


    },
  },
};
</script>
<style scoped>
.row-items {
  height: calc(100vh - 240px);
  margin-top: 10px;
  overflow-y: auto;
  overflow-x: hidden;
}

.item-name {
  /* width: 150px;  */
  overflow: hidden;
  white-space: nowrap;
  /*规定文本不进行换行*/
  text-overflow: ellipsis;
  cursor: pointer;
}

.content {
  padding: 10px 30px;
  background-color: #fff;
  box-sizing: border-box;
}

.pro-left {
  border-radius: 6px 0 0 6px;
  background-image: -webkit-linear-gradient(45deg, #38a8f6, #767cfc);
  position: absolute;
  height: 100%;
  color: #fff;
  width: 11%;
  margin-top: -6px;
}

.proRow {
  border-radius: 6px;
  background-color: #ebf0f4;
  margin: 12px 0;
  padding: 6px 0;
  min-height: 90px;
}

.pro-right {
  border-radius: 0px 8px 8px 0px;
  min-height: 92px;
}

.proxx {
  width: 12px;
  height: 12px;
  border-radius: 6px;
  /* background: crimson; */
  display: inline-block;
  /* border: crimson 1px solid; */
  /* background-color: #13ce66; */
}

.primaryButton {
  background-color: #409EFF;
  border-color: #409EFF;
}

.pro {
  display: flex;
  height: 30px;
  line-height: 30px;
}

.title {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.center-horizontal {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}

.title :hover {
  /* color: #38a8f6; */
  text-decoration: underline;
  cursor: pointer;
}

.pro-title {
  height: 28px;
  line-height: 28px;
  padding: 0;
  font-size: 14px;
}

.pro-title .item {
  height: 48px;
  width: 88px;
  display: inline-block;
}

.process-title {
  float: right;
  font-size: 14px;
  margin-top: 5px;
}
</style>
<style>
.leftButton {
  display: inline-block;
  background-color: #409EFF;
  border-color: #409EFF;
  border-radius: 4px 0 0 4px;
}

.leftButton>.el-button-group>.el-button:last-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-radius: 0px !important;
}

.rightButton {
  display: inline-block;
}

.rightButton>.el-radio-button:first-child .el-radio-button__inner {
  border-radius: 0px !important;
}
</style>